import gql from 'graphql-tag';

export namespace VariantFragments {
  export const Variant = gql`
    fragment Variant on IVariant {
      id
      name
      sortOrder
      soldCount
      ... on CitizenshipVariant {
        shopifyIdEU
        shopifyIdUS
      }
      ... on PassportVariant {
        shopifyIdEU
        shopifyIdUS
      }
      ... on MeetAndGreetVariant {
        cap
      }
      ... on ProductVariant {
        shopifyIdEU
        shopifyIdUS
        outOfStockEU
        outOfStockUS
      }
      ... on PhotoPrintVariant {
        shopifyIdEU
        shopifyIdUS
        printWidth
        printHeight
      }
    }
  `;

  export const PhotoPrintVariant = gql`
    fragment PhotoPrintVariant on PhotoPrintVariant {
      id
      name
      sortOrder
      price
      hasPrice
      shopifyIdEU
      shopifyIdUS
      printWidth
      printHeight
      applyToShowPhotos
      applyToMeetAndGreetPhotos
    }
  `;
}
